import React from 'react'

import { IconTextStyled, IconTextMediaStyled, IconTextContentStyled } from './styles'
import ImageStatic from './../ImageStatic'
import { IconTextProps } from './types'

const IconText: React.FC<IconTextProps> = ({ title, icon }) => {
  return (
    <IconTextStyled>
      {icon && (
        <IconTextMediaStyled>
          <ImageStatic image={icon} />
        </IconTextMediaStyled>
      )}
      {title && <IconTextContentStyled>{title}</IconTextContentStyled>}
    </IconTextStyled>
  )
}

export default IconText
